import { HelpArticle } from "@/components/HelpArticle/HelpArticle";
import { createFileRoute } from "@tanstack/react-router";

const title = "Hvilke saker kan ikke sendes inn elektronisk?";

export const Route = createFileRoute("/_authenticated-user/hjelp/saker-som-ikke-kan-sendes-elektronisk/")({
  head: () => ({
    meta: [{ title: `${title} | Alice & Bob` }],
  }),
  component: Page,
});

function Page() {
  return (
    <HelpArticle title={title}>
      <h2>Når må dokumentet sendes på papir?</h2>
      <p>
        Foreløpig kan ikke alle dokumenttyper og situasjoner sendes inn elektronisk. Vi utvider funksjonaliteten
        fortløpende, og gjør nye dokumenttyper tilgjengelige i Alice & Bob så snart Kartverket åpner for elektronisk
        innsending.
      </p>
      <p>Nedenfor finner du en oversikt over saker som begrenses av Kartverket og per i dag må sendes inn på papir:</p>

      <ul>
        <li>
          <strong>Umyndige selgere eller kjøpere</strong>
        </li>
        <li>
          <strong>Innløsning av festetomt</strong>
          <p>
            Det er ikke mulig å sende inn sletting av festekontrakt elektronisk. Dette gjelder også overdragelser der
            sletting av festekontrakt inngår som en del av transaksjonen, inkludert tilfeller hvor slettingen forsøkes
            sendt inn som vedlegg til en elektronisk overdragelse.
          </p>
          <p>
            Årsaken er at sletting av festekontrakt ofte krever manuell vurdering, både juridisk og teknisk, før
            endringen kan registreres i grunnboken. Slettingen kan blant annet påvirke andre registrerte rettigheter,
            kreve signatur fra flere parter eller utløse øvrige endringer i grunnboken.
          </p>
        </li>
        <li>
          <strong>Særskilte avtaler (punkt 6 i skjøte)</strong>
          <p>
            Kartverket har ikke åpnet for elektronisk innsending av tilleggsbestemmelser eller særskilte avtaler i punkt
            6 i skjøte. Dette kan heller ikke lastes opp som vedlegg til elektronisk innsending av skjøte.
          </p>
        </li>
        <li>
          <strong>Sletting av heftelser med vedlegg</strong>
          <p>
            Ved elektronisk sletting av heftelser godtar ikke Kartverket vedlegg. Dersom rettighetshaver ikke kan
            signere med BankID, kan fullmakt eller annen dokumentasjon derfor ikke benyttes ved elektronisk innsending.
          </p>
        </li>
        <li>
          <strong>Rettighetshaver registrert med løpenummer</strong>
          <p>
            Rettighetshavere registrert med løpenummer kan ikke identifiseres maskinelt i det elektroniske
            signeringsløpet. Kartverket har heller ikke åpnet for å benytte hjelpedokumentasjon eller annen
            identifikasjon som vedlegg i disse sakene.
          </p>
          <p>
            Merk: Rettighetshaver kan skriftlig be Kartverket om å endre registreringen i grunnboken fra løpenummer til
            fødselsnummer. Når endringen er gjennomført, kan dokumentet tinglyses elektronisk.
          </p>
        </li>
        <li>
          <strong>Tresidig skjøte hvor utsteder er privatperson</strong>
          <p>
            Kartverket har foreløpig kun åpnet opp for elektronisk tinglysing av tresidig skjøte hvor utsteder er et
            selskap.
          </p>
        </li>
        <li>
          <strong>Inkuriepåtegning</strong>
        </li>
      </ul>
    </HelpArticle>
  );
}
